import { hasWindow } from "@litres/utils";
import { type AxiosBaseQueryError } from "../baseQuery";

/*
  Клиентский аналог серверной ошибки: 503 Service Unavailable
  В этот статус вкладываем смысл ошибки: Network Error c дополнительной проверкой на статус сети
*/
export const OFFLINE_STATUS_ERROR = 53;
/*
  Клиентский аналог серверной ошибки: 504 Gateway Timeout
*/
export const CLIENT_TIMEOUT_STATUS_ERROR = 54;

class ClientRequestError extends Error {
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
    this.name = this.constructor.name;
  }

  status: number;
}

export class TimeoutError extends ClientRequestError {
  constructor(message = "Client Timeout Error") {
    super(message, CLIENT_TIMEOUT_STATUS_ERROR);
  }
}

export class OfflineError extends ClientRequestError {
  constructor(message = "Network Error") {
    super(message, OFFLINE_STATUS_ERROR);
  }
}

/**
 * @link https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/onLine
 */
function isOnline() {
  if (hasWindow && navigator.onLine !== undefined) {
    return navigator.onLine;
  }

  return true;
}

/*
    Проверяет случаи, при которых мы можем повторять запрос.
    - ECONNABORTED - ошибка client timeout
    - ERR_NETWORK - возникает при любой проблеме с сетью. Нас интересует статус сети.
*/
export function getUniversalError(error: AxiosBaseQueryError) {
  if (
    error.code === "ECONNABORTED" &&
    typeof error.data === "string" &&
    error.data.includes("timeout")
  ) {
    return new TimeoutError();
  }

  if (error.code === "ERR_NETWORK" && !isOnline()) {
    return new OfflineError();
  }

  return error;
}
